/**
 * Learn more about using TypeScript with React Navigation:
 * https://reactnavigation.org/docs/typescript/
 */

import { BottomTabScreenProps } from "@react-navigation/bottom-tabs";
import {
  CompositeScreenProps,
  NavigatorScreenParams,
} from "@react-navigation/native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";

import { Clazz, AppContext } from "../linked-types";

declare global {
  namespace ReactNavigation {
    interface RootParamList extends RootStackParamList {}
  }
}

export type RootStackParamList = {
  Root: NavigatorScreenParams<RootTabParamList> | undefined;

  Clazzes: undefined;
  Clazz: { clazzId?: Clazz["id"] };

  Modal: undefined;
  NotFound: undefined;
};

export type RootStackScreenProps<Screen extends keyof RootStackParamList> =
  NativeStackScreenProps<RootStackParamList, Screen>;

export type RootTabParamList = {
  Syllabi: undefined;
  Videos: undefined;
  Moves: undefined;
  Families: undefined;
  ViewSyllabi: undefined;
  Classes: undefined;
};

export type RootTabScreenProps<Screen extends keyof RootTabParamList> =
  CompositeScreenProps<
    BottomTabScreenProps<RootTabParamList, Screen>,
    NativeStackScreenProps<RootStackParamList>
  >;

export enum TokenType {
  Refresh = "Refresh",
  Bearer = "Bearer",
}

export interface Authorization {
  tokenType: TokenType;
  accessToken: string;
  refreshToken: string;
}

export type Environment = "development" | "production";

export type Theme = "light" | "dark";

export interface Preferences extends AppContext {
  theme?: Theme;
}

export * from "../linked-types";
